import React, { Fragment } from 'react';
import { Row, Spinner } from 'react-bootstrap';
import styled from 'styled-components';
import CommonTable from 'components/CommonTable';
import { CustomButton } from 'components/CustomForm';
import useModal from 'hooks/useModal';
import AddUnionModal from './AddUnionModal';
import { deleteUnion, getUnions } from 'network//apis/InformationApi';
import CommonPrompt from "components/DeletePrompt";
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { TiDocumentDelete } from 'react-icons/ti';
import { TbEditCircle } from 'react-icons/tb';

const cols = [
	{ title: 'حذف', width: '10%' },
	{ title: 'ویرایش', width: '10%' },
	{ title: 'شماره تماس مدیرعامل', width: '20%' },
	{ title: 'نام مدیرعامل', width: '20%' },
	{ title: 'استان', width: '20%' },
	{ title: 'نام ثبتی', width: '20%' },
	{ title: 'ردیف', width: '5%' }
];

const Holder = styled.div`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	width: 100%;
	margin: 0;
	padding: 0 2rem;

	div.header-button {
		display: flex;
		justify-content: end;
		width: 100%;
		margin-bottom: 1.5rem;
	}
	div.loading {
		min-height: 30rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3876e5;
	  }
`;

const UnionsManagementTab = ({ currentTab = 'unions-management-tab' }) => {
	const {
		isOpen,
		handleOpenModal,
		handleCloseModal,
		data: editData,
	  } = useModal();
	  const {
		isOpen: isDeleteModalOpen,
		handleOpenModal: handleOpenDeleteModal,
		handleCloseModal: handleCloseDeleteModel,
		data: deleteModalData,
	  } = useModal();
	
	  const {
		data: unionsData,
		refetch,
		isLoading,
	  } = useQuery(["get-unions"], () => getUnions(), {
		refetchOnWindowFocus: false,
		enabled: currentTab === 'unions-management-tab'
	  });
	
	  const deleteUnionMutation = useMutation(deleteUnion, {
		onSuccess: (res) => {
		  if (res && res.status === 204) {
			toast(`با موفقیت حذف گردید`, {
			  type: "success",
			  position: "bottom-right",
			});
			refetch();
		  }
		},
		onError: () => {
		  toast(`خطا در حذف، لطفا اتصال خود را بررسی کنید`, {
			type: "error",
			position: "bottom-right",
		  });
		},
	  });

	  return (
		<Holder>
		  {isLoading ? (
			<div className="loading">
			  <Spinner animation="border" role="status" />
			</div>
		  ) : (
			<Fragment>
			  <div className="header-button">
				<CustomButton onClick={() => handleOpenModal(null)}>
				  افزودن اتحادیه
				</CustomButton>
			  </div>
			  <CommonTable cols={cols}>
				{unionsData?.data?.map((union, index) => (
				  <tr key={union?.union_id}>
					<td>
					  <TiDocumentDelete
						onClick={() => {
						  handleOpenDeleteModal(union);
						}}
					  />
					</td>
					<td>
					  <TbEditCircle
						onClick={() => {
						  handleOpenModal(union);
						}}
					  />
					</td>
					<td>{union?.ceo_phone_number}</td>
					<td>{union?.ceo_name ?? "-"}</td>
					<td>{union?.province?.name}</td>
					<td>{union?.name}</td>
					<td>{index + 1}</td>
				  </tr>
				))}
			  </CommonTable>
			</Fragment>
		  )}
		  {isOpen && (
			<AddUnionModal
			  isOpen
			  onClose={handleCloseModal}
			  size="md"
			  data={editData}
			  onCreateSuccess={refetch}
			/>
		  )}
		  {isDeleteModalOpen && (
			<CommonPrompt
			  isOpen={isDeleteModalOpen}
			  onClose={handleCloseDeleteModel}
			  onActionTap={() => {
				handleCloseDeleteModel();
				deleteUnionMutation.mutate({ id: deleteModalData?.union_id });
			  }}
			/>
		  )}
		</Holder>
	  );
};

export default UnionsManagementTab;
